import React, { useState } from 'react';
import { fitCallUrl } from '../config/scheduling';
import './Contact.css';

const Contact = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    React.useEffect(() => {
        setIsLoaded(true);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const form = e.target;
        const formData = new FormData(form);

        try {
            const response = await fetch('https://api.web3forms.com/submit', {
                method: 'POST',
                body: formData,
            });
            const result = await response.json();

            if (result.success) {
                setIsSubmitted(true);
                form.reset();
            } else {
                alert('Something went wrong. Please try again.');
            }
        } catch (error) {
            alert('Something went wrong. Please try again.');
        }

        setIsSubmitting(false);
    };

    return (
        <div className={`page contact-page ${isLoaded ? 'loaded' : ''}`}>
            <section className="contact-section">
                <div className="container">
                    <div className="contact-grid">
                        {/* Info Column */}
                        <div className="contact-info">
                            <span className="label">Contact</span>
                            <h1>Start a conversation</h1>
                            <p>
                                Whether you're planning a project, exploring a partnership, or just
                                curious about what's possible—we'd like to hear from you.
                            </p>

                            <div className="contact-booking">
                                <a href={fitCallUrl} className="btn btn-primary contact-booking-link" target="_blank" rel="noopener noreferrer">
                                    Schedule a fit call <span aria-hidden="true">↗</span>
                                    <span className="sr-only"> (opens in a new tab)</span>
                                </a>
                                <p>Free · 15 minutes · Choose a time that works for you.</p>
                            </div>

                            <div className="contact-details">
                                <div className="contact-item">
                                    <span className="contact-label">Email</span>
                                    <a href="mailto:hello@bai-systems.com">hello@bai-systems.com</a>
                                </div>
                                <div className="contact-item">
                                    <span className="contact-label">Phone</span>
                                    <a href="tel:+18014775323">(801) 477-5323</a>
                                </div>
                                <div className="contact-item">
                                    <span className="contact-label">Location</span>
                                    <span>Salt Lake City, UT</span>
                                </div>
                            </div>

                            <p className="response-note">
                                We typically respond within one business day.
                            </p>
                        </div>

                        {/* Form Column */}
                        <div className="contact-form-wrapper">
                            {isSubmitted ? (
                                <div className="form-success">
                                    <h3>Thank you for reaching out.</h3>
                                    <p>We'll be in touch within one business day.</p>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <h2 className="contact-form-title">Prefer to write?</h2>
                                    <input type="hidden" name="access_key" value="c917a05a-3d9c-4b80-bdbb-ac2c2c4b0a45" />
                                    <input type="hidden" name="subject" value="New Contact Form Submission - BAi Systems" />
                                    <input type="hidden" name="from_name" value="BAi Systems Website" />
                                    <input type="checkbox" name="botcheck" style={{ display: 'none' }} />

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label htmlFor="name">Name</label>
                                            <input type="text" name="name" id="name" required />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="email">Email</label>
                                            <input type="email" name="email" id="email" required />
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label htmlFor="company">Company</label>
                                            <input type="text" name="company" id="company" />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="role">Your Role</label>
                                            <select name="role" id="role">
                                                <option value="">Select...</option>
                                                <option value="builder">Builder / GC</option>
                                                <option value="architect">Architect / Designer</option>
                                                <option value="homeowner">Homeowner</option>
                                                <option value="integrator">Integrator / Installer</option>
                                                <option value="developer">Developer</option>
                                                <option value="other">Other</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="projectType">Project Type</label>
                                        <select name="projectType" id="projectType">
                                            <option value="">Select...</option>
                                            <option value="new-construction">New Construction</option>
                                            <option value="renovation">Renovation / Retrofit</option>
                                            <option value="partnership">Partnership Inquiry</option>
                                            <option value="consultation">General Consultation</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="message">Message</label>
                                        <textarea name="message" id="message" rows="6" required></textarea>
                                    </div>

                                    <button type="submit" className="btn btn-primary btn-full" disabled={isSubmitting}>
                                        {isSubmitting ? 'Sending...' : 'Send Message'}
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
